// src/services/studentTransactionServices.js
import axiosClient from "./axiosClient";

const route = "/studentPayment";

// Create a new student transaction
export const createStudentTransaction = async (transactionData) => {
  try {
    const response = await axiosClient.post(`${route}`, {
      date: transactionData.date,
      notes: transactionData.notes,
      studentYearId: transactionData.studentYearId,
      studentCategoryId: transactionData.studentCategoryId,
      studentId: transactionData.studentId,
      amount: transactionData.amount,
      transactionType: transactionData.transactionType,
      kassaId: transactionData.kassaId,
      receiptNumber: transactionData.receiptNumber,
      type: transactionData.type,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
